import React, { Component } from 'react';
import AiImageBigWrap from './AiImageBigWrap';
import Sticky  from "react-sticky-el";
import {OPTION_URL, DEFAULT_Z_QSKU} from '../constants';

//import {Button} from 'primereact/components/button/Button';

class LeftPanel extends Component { 
    render() {
      var splashScreen = (this.props.type === '0')
      var zsku=<div>{this.props.cfg}</div>
      if (window.currentSite ==='zales')
        zsku = <div>{DEFAULT_Z_QSKU}</div>
          

      return (<div id="ai-panel" className='ai-left-panel' >
    <Sticky className="ai-sticky-left" topOffset={0}>  
    <div className={"ai-cfg" + (splashScreen ? ' hideStart' : '')}>SKU #{zsku}-{this.props.sh.slice(1)}</div>
    <div className={'ai-title' + (this.props.size === 'big' ? '-big' : '')}>{this.props.title}</div>
    <i className={"ai-startover" + (splashScreen ? ' hideStart' : '')}
        onClick={() => {if(this.props.isku!==this.props.sku){this.props.onStartOver()}}}>
        <img className="ai-startover-button" 
        src={OPTION_URL + "small/button/so3.png"} alt=""
        srcSet={OPTION_URL + "small/button/so3.png 1x, " +OPTION_URL + "large/button/so3.png 2x"}
        draggable="false"
        onDragStart={(e) => { e.preventDefault() }}
        />
        </i>
    <i className={"ai-zoom" + (splashScreen ? ' hideStart' : '')}>
        <img className="ai-zoom-button" 
        src={OPTION_URL + "small/button/z3.png"} 
        srcSet={OPTION_URL + "small/button/z3.png 1x, " +OPTION_URL + "large/button/z3.png 2x"}
        onClick={this.props.onPushOpenBox}
        alt=""
        draggable="false"
        onDragStart={(e) => { e.preventDefault() }}
        />
        </i> 
    <AiImageBigWrap size={this.props.size}  orientation={this.props.orientation}/> 
    </Sticky> 
    
      </div>
        );
    }
}



export default LeftPanel;


// WEBPACK FOOTER //
// ./src/layout/LeftPanel.js